export default __webpack_public_path__ + "static/media/coin_booster.fb4879cd.svg";